module.exports = __webpack_public_path__ + "static/img/iconfont.937b183f.svg";